import React from 'react';
import { Gift, Download, MessageCircle } from 'lucide-react';
import Button from './common/Button';

const Bonus = () => {
  const bonusItems = [
    {
      icon: <Gift className="w-12 h-12 text-[#f2055c]" />,
      title: "Acesso às aulas gravadas",
      description: "Reveja o conteúdo quantas vezes quiser, e quando quiser."
    },
    {
      icon: <Download className="w-12 h-12 text-[#f2055c]" />,
      title: "Seu guia definitivo para configurar sua máquina do jeito certo",
      description: "Baixe agora o e-book exclusivo e comece a usar seu setup com performance máxima em minutos."
    },
    {
      icon: <MessageCircle className="w-12 h-12 text-[#f2055c]" />,
      title: "Comunidade fechada no WhatsApp",
      description: "Tire suas dúvidas diretamente com a Daniele e outros alunos."
    }
  ];

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-16 md:py-20 bg-[#0d0d0d] text-white">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">O que você ganha se inscrevendo hoje:</h2>
          <div className="w-24 h-1 bg-[#f2055c] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {bonusItems.map((item, index) => (
            <div 
              key={index} 
              className="bg-white/5 p-6 rounded-lg border border-white/10 hover:border-[#f2055c]/50 transition-colors duration-300 animate-fadeInUp"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="flex flex-col items-center text-center">
                <div className="mb-4">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-2 text-white">{item.title}</h3>
                <p className="text-gray-300">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center animate-pulse">
          <Button onClick={handleScrollToTop} size="large">
            Quero garantir minha vaga agora
          </Button>
          <p className="mt-4 text-gray-400 text-sm">
            Inscrições limitadas. Garanta sua vaga enquanto ainda há tempo!
          </p>
        </div>
      </div>
    </section>
  );
};

export default Bonus;